import axiosNest from '../../api/axiosNest';
import type { BankListParams } from './bankFtl';

/**
 * Zapisane widoki listy — wywołania API (`apps/api/src/saved-list-views/`,
 * makieta FTL pkt 9.3, przełącznik `bankSavedViews`, 15.10.2026). Widoki są
 * prywatne: konto bierze API z tokenu.
 */

export const SAVED_VIEWS_URL = '/saved-list-views';

/** Lista banku — wartość to dane API (`SAVED_VIEW_RESOURCES`). */
export const BANK_VIEWS_RESOURCE = 'user-offers';

export interface SavedView {
  id: number;
  name: string;
  params: {
    filter: Record<string, unknown>;
    displayedFilters: Record<string, boolean>;
    sort: string | null;
    order: 'ASC' | 'DESC' | null;
  };
}

export async function fetchSavedViews(): Promise<SavedView[]> {
  const { data } = await axiosNest.get<SavedView[]>(SAVED_VIEWS_URL, {
    params: { resource: BANK_VIEWS_RESOURCE },
  });
  return Array.isArray(data) ? data : [];
}

export async function saveView(name: string, params: BankListParams): Promise<SavedView> {
  const { data } = await axiosNest.post<SavedView>(SAVED_VIEWS_URL, {
    resource: BANK_VIEWS_RESOURCE,
    name,
    params: {
      filter: params.filter,
      displayedFilters: params.displayedFilters,
      sort: params.sort ?? null,
      order: params.order ?? null,
    },
  });
  return data;
}

export async function deleteView(id: number): Promise<void> {
  await axiosNest.delete(`${SAVED_VIEWS_URL}/${id}`);
}
